import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import './assets/sass/main.scss';

Vue.config.productionTip = false;

store.dispatch('INIT').then(() => {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
});
